import React, { useEffect } from "react";
import { Button, Table, Select } from "antd";
import { useModel, useModelDispatchers } from "../../../models";
import { CM_ACTION_TYPE, ENV } from "../../../utils/constants";
import { YhAuth } from "../../../components/Auth";
import { ResourceAuthEnum } from "../../../utils/resourcesAuth";

const { Option } = Select
const columns = [
    {
        title: '公司',
        dataIndex: 'orgName',
    },
    {
        title: '货架名称',
        dataIndex: 'shelvesName',
        align: 'left',
    },
    {
        title: '货架编号',
        dataIndex: 'shelvesCode',
        align: 'left',
    },
    {
        title: '所属仓库',
        dataIndex: 'warehouseName',
    },
    {
        title: '所属区域',
        dataIndex: 'areaName',
    },
    {
        title: '备注',
        dataIndex: 'shelvesDesc',
    },
];


export default function () {
    const [
        { shelveList, areaList, selectedShelve, pageShelveList, shelveSelectedRowKeys, selectedWarehouse, tabsKey },
        { setShelveDrawerVisible, setSelectedShelve, setShelveActionType, loadShelve, setShelveSelectedRowKeys }
    ] = useModel("warehouse");
    const [{ userInfo }] = useModel("global");
    useEffect(() => {
        loadShelve({ showMsg: false, data: { warehouseId: selectedWarehouse ? selectedWarehouse.id : '', orgId: userInfo.orgId, pageSize: 15, pageNum: 1 } });
    }, [tabsKey])
    const onAdd = () => {
        setShelveDrawerVisible(true);
        setShelveActionType(CM_ACTION_TYPE.INSERT);
    }
    const onEdit = () => {
        setShelveDrawerVisible(true);
        setShelveActionType(CM_ACTION_TYPE.EDIT);
    }
    const _onChange = (value, option) => {
        let data = {
            "warehouseId": selectedWarehouse.id,
            "orgId": "",
            "areaId": value,
            pageSize: 15,
            pageNum: 1
        }
        loadShelve({ data })
    }

    const onPageChange = (page, pageSize) => {
        let data = {
            "warehouseId": selectedWarehouse.id,
            pageNum: page,
            pageSize: pageSize
        }
        loadShelve({ showMsg: false, data });
    }

    return (
        <>
            <div style={{ margin: "0 0 8px" }}>
                <Select
                    showSearch
                    allowClear={true}
                    style={{ width: "100px" }}
                    placeholder="所属区域"
                    filterOption={(input, option) => option.label.indexOf(input) >= 0}
                    options={areaList.map(el => ({ label: el.areaName, value: el.id }))}
                    onChange={_onChange}
                />
                <YhAuth resCode={ResourceAuthEnum.DATA_W_ED_SHELVES_AD}>
                    <Button className="margin-left-16" type="primary" onClick={onAdd}>新增</Button>
                </YhAuth>
                <YhAuth resCode={ResourceAuthEnum.DATA_W_ED_SHELVES_ED}>
                    <Button className="margin-left-16" onClick={onEdit} disabled={!!!selectedShelve}>编辑</Button>
                </YhAuth>
            </div>

            <Table
                columns={columns}
                dataSource={shelveList}
                bordered
                pagination={{
                    hideOnSinglePage: true,
                    defaultCurrent: 1,
                    defaultPageSize: 15,
                    onChange: onPageChange,
                    total: pageShelveList.total,
                    current: pageShelveList.pageNum,
                }}
                onRow={record => {
                    return {
                        onClick: event => {
                            if (selectedShelve && selectedShelve.key === record.key) {
                                setSelectedShelve(null);
                                setShelveSelectedRowKeys([]);
                            } else {
                                setSelectedShelve(record);
                                setShelveSelectedRowKeys([record.key]);
                            }
                        },
                    };
                }}
                rowSelection={{
                    hideSelectAll: true,
                    type: 'radio',
                    onChange: (selectedRowKeys, selectedRows) => {
                        // console.log('selectedRowKeys:', selectedRowKeys, 'selectedRows: ', selectedRows);
                        /*if (selectedRows.length > 0) {
                            setSelectedShelve(selectedRows[selectedRows.length - 1]);
                            setShelveSelectedRowKeys([selectedRows[selectedRows.length - 1].key]);
                        } else {
                            setSelectedShelve([]);
                            setShelveSelectedRowKeys([]);
                        }*/
                        setSelectedShelve(selectedRows[0]);
                        setShelveSelectedRowKeys(selectedRowKeys);

                    },
                    getCheckboxProps: record => ({
                        disabled: record.name === 'Disabled',
                        name: record.name,
                    }),
                    selectedRowKeys: shelveSelectedRowKeys,
                }}
                scroll={{ x: 'max-content' }}
            />
        </>
    )
}